import useRecord from "../../api/api-hooks/records/useRecord";
import WidgetError from "./WidgetError";

interface Props {
  section: any;
  setSettings: any;
}

const DocumentWidget = ({ section, setSettings }: Props) => {
  let { record, recordLoading } = useRecord({
    moduleAPIName: section?.Document?.ModuleAPIName,
    recordID: section?.Document?.id,
  });

  recordLoading =
    recordLoading && !window.location.pathname.startsWith("/shared-view");

  return (
    <>
      {recordLoading && section?.Document?.id ? (
        <>
          <div className="skeleton document-skeleton-rg"></div>
        </>
      ) : (
        <>
          {!section?.Document || !record?.Body?.RichText ? (
            <WidgetError
              title="No Document Selected"
              description="No document has been selected for this widget."
              onOpenSettings={setSettings ? () => setSettings(section) : null}
            />
          ) : (
            <div
              className="px-2 pb-2 richtext-document ql-editor ql-snow"
              style={{
                maxWidth: "100%",
                height: "unset",
                marginTop: 0,
              }}
              dangerouslySetInnerHTML={{ __html: record?.Body?.RichText }}
            ></div>
          )}
        </>
      )}
    </>
  );
};

export default DocumentWidget;
